import { connect } from 'react-redux'

import {
  getOrganizationId,
  getOrganization,
} from 'data/organizations/selectors'

function IfPaidPlan({ isPaid, children, show = true }) {
  return isPaid === show ? children : false
}

export const provideIsPaidPlan = connect(state => {
  const organizationId = getOrganizationId(state)
  const organization = getOrganization(state, organizationId)
  return {
    isPaid: organization.product !== 'free',
  }
})

export default provideIsPaidPlan(IfPaidPlan)
